import { DirectPayPrimaryService } from "#/lib/carrot-api/types/DirectPayPrimaryService"

export enum CannotBeSubmittedReason {
  DENIED = "DENIED",
  NO_ADD_ONS = "NO_ADD_ONS",
  NOT_RELATED = "NOT_RELATED"
}

// Denied wins over no add-ons.
export function getCannotBeSubmittedReason(
  answer: string | null,
  service: DirectPayPrimaryService | null
): CannotBeSubmittedReason | null {
  if (service?.expenseState === "DENIED") return CannotBeSubmittedReason.DENIED
  if (service && !service.hasAddOns) return CannotBeSubmittedReason.NO_ADD_ONS
  if (!service && answer === "NO") return CannotBeSubmittedReason.NOT_RELATED
  return null
}
